<div
  style="
    width: auto;
    height: 100%;
    padding: 8px 0 4px 8px;
    display: flex;
    flex-direction: column;
  "
  #wrapper
>
  <ng-container *ngIf="_filter">
    <form>
      <div
        class="row-layout"
        [ngClass]="{
          'flex-content-space-between': _ts && _ds,
          'flex-content-end': !(_ts && _ds)
        }"
      >
        <div *ngIf="_ts" style="margin-right: 1.5rem; flex: 1">
          <mat-form-field
            floatLabel="always"
            style="min-width: 10rem; width: 90%"
          >
            <mat-label>Suchtext</mat-label>
            <input
              matInput
              type="text"
              style="width: 100%"
              placeholder="Suchtext eingeben"
              [formControl]="inputFC"
            />
          </mat-form-field>
        </div>
        <div *ngIf="_ds">
          <div
            class="row-layout"
            style="flex: 2; padding-left: 1rem; justify-content: flex-end"
          >
            <div
              class="row-layout"
              style="align-items: center; margin-right: 1rem"
            >
              <div style="margin-right: 0.5rem">Von:</div>
              <app-date-picker
                [no-hint]="true"
                [value]="startDate"
                (valueChange)="onStartDateChange($event)"
              ></app-date-picker>
            </div>
            <div
              class="row-layout"
              style="align-items: center; margin-right: 1.5rem"
            >
              <div style="margin-right: 0.5rem">Bis:</div>
              <app-date-picker
                [no-hint]="true"
                [value]="endDate"
                (valueChange)="onEndDateChange($event)"
              ></app-date-picker>
            </div>
            <div style="padding-top: 12px; margin-right: 1rem">
              <button
                mat-button
                (click)="search()"
                class="light-bg-color"
                style="height: 40px"
              >
                Suche starten
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </ng-container>
  <div style="flex: 1">
    <div #gridWrapper style="width: 100%; height: calc(100% - 16px)">
      <ag-grid-angular
        #grid
        *ngIf="showGrid"
        [suppressRowTransform]="suppressRowTransform"
        style="height: inherit"
        [ngStyle]="customStyle"
        class="ag-theme-fresh"
        [rowData]="rowData"
        [gridOptions]="gridOptions"
        [overlayNoRowsTemplate]="noRowsTemplate"
      >
        <!--
        [scrollbarWidth]="8"
        [alwaysShowHorizontalScroll]="true"
        [alwaysShowVerticalScroll]="true"
      -->
      </ag-grid-angular>
    </div>
  </div>
</div>
